// Runs after Snowplow populates page/referrer URLs and before it sends events.
export default {
  beforeTrack(payloadBuilder) {
    const payload = payloadBuilder.getPayload()
    for (const field of ['url', 'refr']) {
      if (!payload[field]) continue
      const url = new URL(payload[field], window.location.href)
      if (url.searchParams.has('one_time_token')) {
        url.searchParams.delete('one_time_token')
        payload[field] = url.href
      }
    }
  },
}
